import React, { useEffect, useState } from "react";
import EventImage from "assets/images/common/others/exploreEvents.png";
import useUsers from "containers/user-management/useHooks";
import { useSelector } from "react-redux";
import { EVENT_STATUS } from "utils/helpers/enums/shared.enum";
import DataNotFound from "components/particles/table/data-not-found";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";

interface Props {
  Id: any;
}

const TicketPass = ({ Id }: Props) => {

  const { getEventByUserID } = useUsers();
  const { isLoading } = useSelector((state: any) => state.sharedReducer);

  const [data, setData] = useState<any[]>([]);
  useEffect(() => {
    getEventByUserID(
      { childId: Id, status: EVENT_STATUS.JOINED },
      setData
    );
  }, [Id]);
  return (
    <div className="flex flex-wrap gap-4 pt-4">
      {data.map((exp: any, index: number) => (
        <div
          key={index}
          className="bg-ticketBg rounded-2xl shadow-lg w-[280px]  border border-gray-200"
        >
          {/* Top Section */}
          <div className="px-4 pt-4">
            <div className="flex bg-white rounded-2xl p-2 items-center space-x-3 ">
              <img
                src={concatPathWithBackendUrl(
                  exp.eventPicsUrl![0]?.fileDownloadUri
                )}
                alt="Event"
                className="w-14 h-14 rounded-2xl"
              />
              <p className="text-[primaryText] font-semibold text-[11px]">
                {exp?.title || "-"}
              </p>
            </div>
          </div>

          <div className="my-3 "></div>
          <div className="grid grid-cols-3 gap-4 px-5 py-2">
            <div>
              <p className="text-[11px] text-mutedText">Start Time</p>
              <p className="text-sm text-darkSlateBlueText font-semibold">
                {new Date(exp?.workshopSessions[0]?.startDateTime || "-").toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
              </p>
            </div>
            <div>
              <p className="text-[11px] text-mutedText">End Time</p>
              <p className="text-sm text-darkSlateBlueText font-semibold">
                {new Date(exp?.workshopSessions[0]?.endDateTime || "-").toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
              </p>
            </div>
            <div>
              <p className="text-[11px] text-mutedText">Price</p>
              <p className="text-sm text-darkSlateBlueText font-semibold">
                ${exp?.entryFee || "0"}
              </p>
            </div>
          </div>

          {/* Bottom Section */}
          <div className="my-3  border-t-2 border-dashed border-dividerGray"></div>
          <div className="flex items-center flex-wrap gap-4 px-5 pt-2 pb-4">
            {/* <div>
              <p className="text-[11px] text-mutedText">Name</p>
              <p className="text-sm text-darkSlateBlueText font-semibold">
                {exp?.host?.user?.firstName || "-"}{""}
              </p>
            </div> */}

            <div>
              <p className="text-[11px] text-mutedText">Date</p>
              <p className="text-sm text-darkSlateBlueText font-semibold">
                {new Date(exp?.workshopSessions[0]?.startDateTime || "-").toLocaleDateString('en-GB', {
                  day: '2-digit',
                  month: 'long',
                  year: 'numeric',
                })}
              </p>
            </div>

            <div>
              <p className="text-[11px] text-mutedText">Address/Location</p>
              <p className="text-sm text-darkSlateBlueText font-semibold">
                {exp?.location || "-"}
              </p>
            </div>
          </div>
        </div>
      ))}
      <div className="mt-10 text-9xl">
        <DataNotFound show={!isLoading && !data.length} />
      </div>
    </div>
  );
};

export default TicketPass;
